import { mc, StyleProps } from '@styles';
import React, { FC, ReactNode } from 'react';

import ChevronDownIcon from './assets/chevronDown.inline.svg';
import ChevronRightIcon from './assets/chevronRight.inline.svg';

interface Props extends StyleProps {
  children?: ReactNode;
  to?: string;
  leftIcon?: Icon;
  rightIcon?: Icon;
  target?: string;
  fontSize?: 'base' | 'lg';
  fontWeight?: 'medium' | 'bold';
}

type Icon = 'chevronDown' | 'chevronRight';

export const TextBtn: FC<Props> = ({
  style,
  className,
  to,
  target,
  children,
  leftIcon,
  fontWeight = 'medium',
  fontSize = 'base',
  rightIcon,
}) => {
  return (
    <a
      style={{ ...style }}
      className={mc(
        'inline-block',
        'font-raleway leading-normal',
        fontWeight === 'medium' && 'font-medium',
        fontWeight === 'bold' && 'font-bold',
        fontSize === 'base' && 'text-base',
        fontSize === 'lg' && 'text-lg',
        'text-ocean-blue hover:text-ocean-blue stroke-ocean-blue',
        'hover:opacity-70',
        'flex flex-row items-center',
        'border-b border-solid border-ocean-blue rounded-none',
        className,
      )}
      href={to}
      target={target}
    >
      {leftIcon === 'chevronDown' && <ChevronDownIcon className="block" />}
      <span className="block">{children}</span>
      {rightIcon === 'chevronRight' && <ChevronRightIcon className="ml-2 block" />}
    </a>
  );
};

export type TextBtnProps = Props;
export default TextBtn;
